import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { obtenerPeriodosUseCase } from "../../../core/inventarios/application/obtenerPeriodoInventario.usecase.js";
import { modificarInventarioUseCase } from "../../../core/inventarios/application/registrarModificacionInventario.usecase.js";

const InventarioPeriodoContext = createContext(null);

export const usePeriodoInventario = () => useContext(InventarioPeriodoContext);

export function InventarioPeriodoProvider({ children }) {
  // ✅ Estados correctos
  const [periodos, setPeriodos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  // Listar periodos
  const listarPeriodos = useCallback(async (filtros = {}) => {
    setLoading(true);
    try {
      const data = await obtenerPeriodosUseCase(filtros);
      setPeriodos(data || []);
      console.log("[InventarioPeriodoProvider] Periodos cargados:", data);
    } catch (error) {
      console.error("[InventarioPeriodoProvider] Error:", error);
      setMensaje(`Error cargando periodos: ${error.message}`);
    } finally {
      setLoading(false);
    }
  }, []);

  // Cambiar estado de un periodo
const cambiarEstado = async ({ periodoId, estado }) => {
  if (!periodoId || !estado) throw new Error("Parámetros inválidos");

  try {
    // llama al use case que devuelve un Promise
    const resultado = await modificarInventarioUseCase({ periodoId, estado });
    console.log("[Contexto] Resultado de la modificación:", resultado);

    // recarga la lista después del cambio
    await listarPeriodos();

    return resultado; // así tu VentanaPeriodo puede recibir el resultado
  } catch (error) {
    console.error("[Contexto] Error en cambiarEstado:", error.message || error);
    throw error; // relanza para que el catch de la ventana funcione
  }
};

  // Carga inicial
  useEffect(() => {
    listarPeriodos();
  }, [listarPeriodos]);

  return (
    <InventarioPeriodoContext.Provider
      value={{
        periodos,
        loading,
        mensaje,
        listarPeriodos,
        cambiarEstado,
        setMensaje,
      }}
    >
      {children}
    </InventarioPeriodoContext.Provider>
  );
}